module.exports = function isBoolean(x) {
  return x === true || x === false;
};


//////////////////
// WEBPACK FOOTER
// ./~/tcomb/lib/isBoolean.js
// module id = 196
// module chunks = 0